export const LOGIN_REDIRECT = '/'
export const HOME_REDIRECT = '/'